module.exports = __webpack_public_path__ + "img/6.343c4630.png";